
import React from 'react';
import { Phase, FAQItem } from './types';

export const COLORS = {
  primary: '#0a0a0a',
  accent: '#FFC222',
  textSecondary: '#a1a1aa'
};

// Use a more reliable direct-link format for Google Drive assets
export const LOGO_URL = "https://lh3.googleusercontent.com/d/1SS0n4biTJyvMTumqMtYe2VhuGmQJNs3v";

export const PHASES: Phase[] = [
  {
    id: 1,
    title: "Phase 1",
    subtitle: "Junior 실무 & PIC 출전",
    description: "가입 후 주니어 팀을 구성하여 한 달간 프로젝트 기획 및 실행하고, 타 대학과 경쟁하는 PIC(Project Idea Contest : 아이디어 피칭 대회)에 출전합니다."
  },
  {
    id: 2,
    title: "Phase 2",
    subtitle: "BM 고도화 및 인큐베이팅",
    description: "린 캔버스 작성, 수익 구조 설계 및 MVP 기획 과정을 거칩니다. 아이디어가 실질적인 수익과 성과로 이어지도록 교육과 피드백이 진행됩니다."
  },
  {
    id: 3,
    title: "Phase 3",
    subtitle: "네트워킹 & 인사이트",
    description: "SC(Starting Ceremony)와 ETC(Enactus Training Conference)를 통해 전국 인액터스 학생들과 교류합니다. 선배 알럼나이 및 전문가 강연을 통해 실무 역량을 높입니다."
  },
  {
    id: 4,
    title: "Phase 4",
    subtitle: "NC 출전 및 WC 도전",
    description: "전국 26개 대학이 참여하는 국내 최대 규모 창업 대회 NC(National Competition)에 출전합니다. 우승 학교 팀은 대한민국 대표로 WC(World Cup)에 진출하여 글로벌 무대에서 경쟁합니다."
  }
];

export const FAQS: FAQItem[] = [
  {
    question: "프로젝트 경험이 없는데 실무 프로젝트에 바로 투입되나요?",
    answer: "네, ENACTUS YM은 'Learning by Doing'을 지향합니다. Phase 1부터 주니어 팀으로 실무에 투입되며, 선배들의 멘토링과 커리큘럼이 병행되므로 충분히 도전 가능합니다."
  },
  {
    question: "NC(National Competition)는 얼마나 큰 대회인가요?",
    answer: "국내 26개 대학이 참여하는 최고 권위의 대학생 소셜 벤처 대회입니다. 대기업 임원 및 CEO로 구성된 심사위원단으로부터 직접 피드백을 받을 수 있는 독보적인 기회입니다."
  },
  {
    question: "방학 활동이 필수인가요?",
    answer: "비즈니스는 학기 중에만 멈춰있지 않습니다. 프로젝트의 연속성과 실질적인 성과 창출을 위해 방학 기간 활동은 필수입니다."
  }
];
